import { ActionTypes, GA2CommissioningSteps, GA2CommissioningStepStatuses, defaultAcqInfo } from './constants';

const initialState = {
  deviceId: null,
  deviceData: null,
  acqInfo: defaultAcqInfo,
  rasterId: null,
  rasterStatus: null,
  rasterData: null,
  antennaDirections: null,
  applyError: null,
  error: null,
  currentStep: null,
  arfcnValues: null,
  stepStatuses: {
    [GA2CommissioningSteps.BEAM_SETTINGS]: GA2CommissioningStepStatuses.PRISTINE,
    [GA2CommissioningSteps.ACQUISITION_INFO]: GA2CommissioningStepStatuses.PRISTINE,
    [GA2CommissioningSteps.ACQUISITION_STATUS]: GA2CommissioningStepStatuses.PRISTINE,
    [GA2CommissioningSteps.BEAM_SELECTION]: GA2CommissioningStepStatuses.PRISTINE,
    [GA2CommissioningSteps.IN_SERVICE]: GA2CommissioningStepStatuses.PRISTINE
  }
};

export function commissioningGA2Reducer(state = initialState, action) {
  switch (action.type) {
    case ActionTypes.SET_STEP:
      return { ...state, currentStep: action.payload };
    case ActionTypes.SET_STEP_STATUS:
      return {
        ...state,
        stepStatuses: {
          ...state.stepStatuses,
          [action.meta]: action.payload
        }
      };
    case ActionTypes.SET_DEVICE:
      return { ...initialState, deviceId: action.payload, currentStep: GA2CommissioningSteps.BEAM_SETTINGS };
    case ActionTypes.SET_DEVICE_DATA:
      return { ...state, deviceData: action.payload };
    case ActionTypes.SET_ACQ_INFO:
      return { ...state,  acqInfo: action.payload };
    case ActionTypes.SET_RASTER:
      return { ...state, rasterId: action.payload };
    case ActionTypes.SET_RASTER_STATUS:
      return { ...state, rasterStatus: action.payload };
    case ActionTypes.SET_RASTER_DATA:
      return { ...state, rasterData: action.payload };
    case ActionTypes.SET_ANTENNA_DIRECTIONS:
      return { ...state, antennaDirections: action.payload };
    case ActionTypes.SET_APPLY_ERROR:
      return { ...state, applyError: action.payload };
    case ActionTypes.CLEAR_APPLY_ERROR:
      return { ...state, applyError: initialState.applyError };
    case ActionTypes.SET_ERROR:
      return { ...state, error: action.payload };
    case ActionTypes.SET_ARFCN_VALUES:
      return { ...state, arfcnValues: action.payload };
    default:
      return state;
  }
}
